export default __webpack_public_path__ + "static/media/inhalationinfo.eb8daffb.svg";